import { render, staticRenderFns } from "./conventionalResults.vue?vue&type=template&id=318fd71e&scoped=true"
import script from "./conventionalResults.vue?vue&type=script&lang=js"
export * from "./conventionalResults.vue?vue&type=script&lang=js"
import style0 from "./conventionalResults.vue?vue&type=style&index=0&id=318fd71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318fd71e",
  null
  
)

export default component.exports